var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trawl-modal-confirm',{attrs:{"ok":_vm.paymentConfirm}},[_c('template',{slot:"trigger"},[_c('a-button',{staticClass:"trawl-button-success"},[_vm._v("Approve")])],1),_vm._v(" "),_c('template',{slot:"text"},[_c('p',[_vm._v("Apakah pembayaran telah berhasil dilunaskan?")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }